module.exports = __webpack_public_path__ + "img/top-0-0.b0b4e304.jpg";